import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'

export const useLeaveType = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [leaveType, setLeaveType] = useState(false)
  const { deleteNewLeaveType, getNewLeaveType } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const getAllLeaveType = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_LEAVETYPE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewLeaveType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const addLeaveType = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_LEAVETYPE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('LeaveType  Added Successfully', success)
        history.push(ROUTES.LEAVE_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }
  const updateLeaveType = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_LEAVETYPE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('Leave Type  Update Successfully', success)
        history.push(ROUTES.LEAVE_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const getLeaveType = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_LEAVETYPE(dto.leaveTypeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setLeaveType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const deleteLeaveType = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_LEAVETYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('LeaveType Deleted Successfully', success)

        deleteNewLeaveType(dto.leaveTypeId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  const deleteManyLeaveType = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_LEAVETYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.leaveTypeId.length} LeaveType Deleted Successfully`, success)

        dto.leaveTypeId.map((item) => deleteNewLeaveType(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || err.response.data.errors[0].msg, error)
        }
      })
  }

  return {
    addLeaveType,
    getAllLeaveType,
    deleteLeaveType,
    getLeaveType,
    leaveType,
    updateLeaveType,
    deleteManyLeaveType,
    loading,
    paginate,
  }
}
